var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9929 5.09964V5.06983C15.9929 2.38261 14.3642 0.799805 11.6079 0.799805H4.38568C1.62872 0.799805 0 2.38261 0 5.06983V10.9227C0 13.6099 1.62872 15.1989 4.38568 15.1989H11.6108C14.367 15.1989 15.9958 13.6099 15.9958 10.9227V10.6779H12.6061C11.0264 10.6758 9.74817 9.42513 9.75031 7.88462C9.75315 6.34758 11.03 5.10242 12.6061 5.09964H15.9929Z",
    opacity: 0.2,
    fill: "#1080FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4268 6.31982C15.7435 6.32052 16.0002 6.5841 16.001 6.90771V8.93213C16.001 9.25654 15.7436 9.51904 15.4268 9.51904H12.8281C12.0668 9.53273 11.3996 8.99756 11.2324 8.23682C11.2128 8.13541 11.2022 8.03171 11.2021 7.92822C11.2009 7.04228 11.9007 6.32288 12.7666 6.31982H15.4268ZM12.7988 7.11963C12.3575 7.11989 11.9993 7.47804 11.999 7.91943C11.999 8.36107 12.3573 8.71898 12.7988 8.71924C13.2405 8.7192 13.5986 8.36121 13.5986 7.91943C13.5983 7.4779 13.2403 7.11966 12.7988 7.11963ZM8.31055 3.8999C8.64804 3.89859 8.92413 4.16457 8.92578 4.49365C8.9272 4.82356 8.65396 5.09269 8.31641 5.09424H3.79688C3.45919 5.09285 3.18608 4.82395 3.1875 4.49463C3.18899 4.16676 3.46136 3.90129 3.79688 3.8999H8.31055Z",
    fill: "#1080FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.5eee3cfc.svg";
export { ForwardRef as ReactComponent };